export default "__VITE_ASSET__DjStDk0r__"